import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const ScoreEvaluationStyles = makeStyles()((theme: Theme) => ({
  container: {
    minHeight: 'calc(100vh - 40px - 165px)',
    padding: '2rem 0rem',
    [theme.breakpoints.up('md')]: {
      minHeight: 'calc(100vh - 50px - 165px)',
      padding: '2.5rem 0',
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: 'calc(100vh - 50px - 97px)',
    },
    [theme.breakpoints.up('xl')]: {
      padding: '5rem 0',
    },
  },
  containerForJourney: {
    padding: '1.5rem 0rem',
    width: 'calc(100vw - 30px)',
    height: '300px',
    margin: 'auto',
    marginTop: '80px',
    [theme.breakpoints.up('sm')]: {
      padding: '2.5rem 0rem',
      marginTop: '100px',
      maxWidth: '668px',
    },
    [theme.breakpoints.up('md')]: {
      width: 'calc(100vw - 40px - 40px)',
      maxWidth: '800px',
    },
    [theme.breakpoints.up('xl')]: {
      height: '368px',
      padding: '5rem 0',
    },
  },
}));
